export const FIELD_NAME = "name";
export const FIELD_ADDRESS = "address";
export const FIELD_DESCRIPTION = "description";
export const FIELD_AVATAR = "avatar";
export const FIELD_PLAYERS = "players";

export const FIELD_NAME_LENGTH = 64;
export const FIELD_DESCRIPTION_LENGTH = 255;
export const FIELD_ADDRESS_LENGTH = 255;
